import Header from "./Header";
import SiteTab from "sites";
import { Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import GeneralMenu from "leftMenu/GeneralMenu";
import LibraryMenu from "leftMenu/LibraryMenu";
import FeatureMenu from "leftMenu/FeatureMenu";
import {
  PrimaryHeading,
  InvalidURL,
  MainButton,
  LimitReachedCard,
} from "commonUI";
import UserModule from "usersModule/index";
import UserMenu from "leftMenu/UserMenu";
import Library from "library";
import SiteSettingRoutes from "siteSettings";
import SecondaryMenu from "siteSettings/Menu";
import { useUserMenu } from "context/UserMenu";
import { BackArrow, RedirectIcon } from "allIcons";
import { isEqual, useSearch, useUtilities, usePathname } from "helpers";
import { useSites } from "api/sites";
import SiteTempleteUsersMenu from "leftMenu/SiteTempleteUsersMenu";
import { SiteSettingsMenu, pageTitles, ModulePrefixes } from "enums";
import useUserPlan from "hooks/plan";
import { t } from "i18next";
import SettingseMenu from "leftMenu/SettingsMenu";
import AccountSettingsRoutes from "accountSettings";
import Dashboard from "dashboard";
import DashboardMenu from "leftMenu/DashboardMenu";
import { useContainer } from "context/Containers";
import { useBrandingAndColors } from "hooks/brandingAndColors";

export default function HomeScreen() {
  const { navigate } = useUtilities();
  const { userMenu, setUserMenu } = useUserMenu();
  const [activeMenu, setActiveMenu] = useState(
    userMenu ?? SiteSettingsMenu.GENERAL_SETTINGS
  );
  const { data: wpslPlan, isLoading: loadingPlanDetails } = useUserPlan();
  const [pathName] = usePathname();
  const { web } = useSearch();
  const { data } = useSites();
  const { leftSideContainer } = useContainer();
  const { data: brandingData } = useBrandingAndColors();

  const siteDetails = data?.site_details?.total_sites?.find((site) =>
    isEqual(site.dl_website_id, web)
  );
  const isLibraryTemplateAllowed = isEqual(wpslPlan?.temp_access, 1);

  useEffect(() => {
    if (pathName === ModulePrefixes.SITES || pathName === "") {
      setActiveMenu(SiteSettingsMenu.GENERAL_SETTINGS);
      setUserMenu(SiteSettingsMenu.GENERAL_SETTINGS);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathName]);

  useEffect(() => {
    if (brandingData?.brand_colors_settings?.accent_color) {
      document.documentElement.style?.setProperty('--theme-blue', brandingData?.brand_colors_settings.accent_color)
    }
    if (brandingData?.brand_colors_settings?.hover_color) {
      document.documentElement.style?.setProperty('--theme-blue-hover', brandingData?.brand_colors_settings.hover_color)
    }
  }, [brandingData?.brand_colors_settings])


  const renderSubMenu = () => {
    if (
      [
        ModulePrefixes.SITES,
        ModulePrefixes.TEMPLATE_LIBRARY,
        ModulePrefixes.USERS,
        ModulePrefixes.ACCOUNT_SETTINGS,
        ModulePrefixes.DASHBOARD,
        "",
      ].includes(pathName)
    )
      return;

    return (
      <SecondaryMenu
        activeMenu={activeMenu}
        setActiveMenu={(val) => {
          setActiveMenu(val);
          setUserMenu(val);
        }}
        isLibraryTemplateAllowed={isLibraryTemplateAllowed}
      />
    );
  };

  const renderLeftMenu = () => {
    if (pathName === ModulePrefixes.SITES) return;
    if (pathName === ModulePrefixes.TEMPLATE_LIBRARY)
      return (
        <div className="left-side-container" ref={leftSideContainer}>
          {isLibraryTemplateAllowed ? (
            <LibraryMenu />
          ) : (
            <LimitReachedCard
              show
              isLoading={loadingPlanDetails}
              title={t("plan.templateLibrary.notIncluded.title")}
              description={t("plan.templateLibrary.notIncluded.description")}
            />
          )}
        </div>
      );
    if (pathName === ModulePrefixes.USERS)
      return (
        <div className="left-side-container relative flex flex-col" ref={leftSideContainer}>
          <UserMenu />
        </div>
      );
    if (pathName === ModulePrefixes.ACCOUNT_SETTINGS)
      return (
        <div className="left-side-container relative" ref={leftSideContainer}>
          <SettingseMenu />
        </div>
      );
    if (pathName === ModulePrefixes.SITE_SETTINGS || pathName === ModulePrefixes.SITE_TEMPLATE) {
      if (activeMenu === SiteSettingsMenu.GENERAL_SETTINGS) {
        return (
          <div className="left-side-container" ref={leftSideContainer}>
            <GeneralMenu />
          </div>
        );
      }
      if (activeMenu === SiteSettingsMenu.FEATURES_SETTINGS) {
        return (
          <div className="left-side-container" ref={leftSideContainer}>
            <FeatureMenu />
          </div>
        );
      }
      if (activeMenu === SiteSettingsMenu.USER_PREFRENCES) {
        return (
          <div className="left-side-container" ref={leftSideContainer}>
            {!isLibraryTemplateAllowed ? <></> : <SiteTempleteUsersMenu />}
          </div>
        );
      }
      if (activeMenu === SiteSettingsMenu.LIBRARY_TEMPLATES) {
        return (
          <div className="left-side-container" ref={leftSideContainer}>
            <LibraryMenu siteTemplate />
          </div>
        );
      }
    }
    if (pathName === ModulePrefixes.DASHBOARD || pathName === "")
      return (
        <div className="left-side-container relative" ref={leftSideContainer}>
          <DashboardMenu />
        </div>
      );
  };

  return (
    <>
      <div className={`home-screen-container `}>
        <Header />
        <div className="main-body-containter">
          <div className="main-body-wrapper box-shadow">
            <div className="main-body-header">
              <div>
                <div className="flex items-center gap-10">
                  {web ? (
                    <BackArrow
                      fill="white"
                      onClick={() => navigate("/sites")}
                    />
                  ) : (
                    ""
                  )}
                  <PrimaryHeading className="text-white">
                    {web
                      ? `${siteDetails?.web_name} ${t(
                        "siteTemplate.siteSetting"
                      )}`
                      : t(pageTitles[pathName]?.title) ??
                      t("siteTemplate.title")}
                  </PrimaryHeading>
                </div>

                {web ? (
                  <p className="explainer-text">
                    {t("siteTemplate.siteSetting.website.url", {
                      url: siteDetails?.web_url ?? "",
                    })}
                  </p>
                ) : (
                  <p className="explainer-text">
                    {pathName === ModulePrefixes.TEMPLATE_LIBRARY &&
                      !isLibraryTemplateAllowed
                      ? ""
                      : t(pageTitles[pathName]?.explainerText) ??
                      t("siteTemplate.explainerText")}
                  </p>
                )}
              </div>
              {web ? (
                <a
                  href={siteDetails?.web_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <MainButton>
                    <RedirectIcon /> {t("common.button.goToWordpressSite")}
                  </MainButton>
                </a>
              ) : (
                ""
              )}
            </div>
            {renderSubMenu()}
            <div
              className="flex bg-theme-card"
              style={{
                borderBottomLeftRadius: "5px",
                borderBottomRightRadius: "5px",
              }}
            >
              {renderLeftMenu()}
              <div
                className={`right-side-container m-6 ${pathName === ModulePrefixes.SITES ||
                  pathName === ModulePrefixes.DASHBOARD ||
                  pathName === "" ||
                  (pathName === ModulePrefixes.TEMPLATE_LIBRARY &&
                    !isLibraryTemplateAllowed &&
                    !loadingPlanDetails)
                  ? "bg-transparent"
                  : ""
                  }`}
              >
                <Routes>
                  <Route exact path={`/`} element={<Dashboard />} />
                  {/* Sites UI routes */}
                  <Route exact path={`/${ModulePrefixes.SITES}`}>
                    <Route exact index element={<SiteTab />} />
                  </Route>

                  <Route exact path={`/${ModulePrefixes.DASHBOARD}`}>
                    <Route exact index element={<Dashboard />} />
                  </Route>

                  {/* Site Setting UI routes */}
                  <Route
                    exact
                    path={`/${ModulePrefixes.SITE_SETTINGS}/*`}
                    element={<SiteSettingRoutes />}
                  />
                  {/* Site Template UI routes */}
                  <Route
                    exact
                    path={`/${ModulePrefixes.SITE_TEMPLATE}/*`}
                    element={<SiteSettingRoutes />}
                  />
                  {/* Library UI routes */}
                  <Route
                    exact
                    path={`/${ModulePrefixes.TEMPLATE_LIBRARY}/*`}
                    element={isLibraryTemplateAllowed ? <Library /> : <></>}
                  />
                  {/* Users UI routes */}
                  <Route
                    exact
                    path={`/${ModulePrefixes.USERS}/*`}
                    element={<UserModule />}
                  />
                  {/* Users Settings routes */}
                  <Route
                    exact
                    path={`/${ModulePrefixes.ACCOUNT_SETTINGS}/*`}
                    element={<AccountSettingsRoutes />}
                  />
                  <Route path={`*`} element={<InvalidURL />} />
                </Routes>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
